/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Compare_Row_Maturity_CcInputs */

const en_cad_compare_row_maturity_cc = /** @type {(inputs: Cad_Compare_Row_Maturity_CcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Early, fast development`)
};

/**
* | output |
* | --- |
* | "Early, fast development" |
*
* @param {Cad_Compare_Row_Maturity_CcInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_compare_row_maturity_cc = /** @type {((inputs?: Cad_Compare_Row_Maturity_CcInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Compare_Row_Maturity_CcInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_compare_row_maturity_cc(inputs)
});
export { cad_compare_row_maturity_cc as "cad.compare.row_maturity_cc" }